<template>
  <div>
    <p>Всего: <strong>{{ getAllOrders() }}</strong></p>
    <p>Смена: <strong>{{ getAllOrders(true) }} ({{ getAllOrders(true, true) }}%)</strong></p>
  </div>
</template>

<script>
export default {
  props: ['allRecords', 'users', 'allUsers'],
  methods: {
    getAllOrders(shift = false, percent = false) {
      let allUsers = [];
      if (shift) {
        allUsers = this.users.map((u) => u.id);
      } else {
        allUsers = this.allUsers.reduce((acc, u) => {
          acc.push(u.id);
          return acc;
        }, [])
      }
      const count = Object.keys(this.allRecords).reduce((acc, k) => {
        if (allUsers.includes(+k)) {
          acc += Object.values(this.allRecords[k] ?? {}).reduce((a, s) => a + s.total, 0)
        }
        return acc;
      }, 0);
      if (percent) {
        const total = this.getAllOrders();
        return Math.round((count ?? 0) * 100 / (total === 0 ? 1 : total));
      }
      return Math.round((count ?? 0) * 10) / 10;
    }
  }

}

</script>
